const APIS = {
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  SYNC_CONTACT: "/contactservice/api/contact-groups/sync/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  CUSTOMER: "/logisticservice/api/customer/",
  CONTACT_GROUP: "/contactservice/api/contact-groups/",
};

export default APIS;
